import axios from 'axios';
import { MonthEnum, PeriodApiParamsEnum } from 'enums/enums';
import { currentMonth, currentYear } from 'utils/utils';
import { setPeriodsForServer } from 'utils/utilsLogic';

let BASE_URL = process.env.REACT_APP_API_BASE_URL;

interface Params {
  [key: string]: any;
}

export const get = async (endpoint: string, params: Params = {}): Promise<any> => {
  const fullUrl = `${BASE_URL}/${endpoint}`;
  const periodsForServer = setPeriodsForServer();
  const year = getYear(periodsForServer);

  const combinedParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {    
    if (value) {
      combinedParams.append(key, String(value));
    }
  });

  combinedParams.append(PeriodApiParamsEnum.Year, year.toString());

  periodsForServer.Months?.forEach(month => {
    combinedParams.append(PeriodApiParamsEnum.Months, month.toString());
  });

  return axios.get(`${fullUrl}?${combinedParams.toString()}`).then(response => response.data);
};

const getYear = (periodsForServer: { Year: number; Months: number[]; }) =>  periodsForServer.Year != null ? 
  (isfirstMonthAtCurrentYear(periodsForServer) ? (currentYear - 1) : periodsForServer.Year) :
  (currentMonth == MonthEnum.January ? (currentYear - 1) : currentYear);

const isfirstMonthAtCurrentYear = (periodsForServer: { Year: number; Months: number[]; }) => periodsForServer.Year == currentYear && periodsForServer.Months.length == 0 && currentMonth == MonthEnum.January;